import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import styled from 'styled-components';

import _ from 'lodash';

import { useDispatch } from 'react-redux';

import swal from '@sweetalert/with-react';
import Template from '../Pagamento/_template';
import { maskDocs, validateDocs, redirectToLtiCourseIfExists } from '../../utils/functions';
import { handleCpfConsultation } from '../../business/payment';
import history from '../../utils/history';
import adsTracking from '../../utils/adsTracking';
import { Creators as ProfileActions } from '../../store/ducks/user/profile/actions';
import { Container } from './styles';
import { gateway } from '../../utils/api';
import LitOnlearning from '../../images/lit.png';
import LogoPlanos from '../../images/sp_lit.png';

import { LitButton } from '../shared/LitButton';
import { Text } from '../shared/LitText/styles';

const MobileHeader = styled.nav`
  display: none;
  
  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem;
    width: 100%;
    background: #27aae1; /* Cor padrão do LIT */
    
    .navbar-brand {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      
      img {
        max-width: 120px;
        height: auto;
        max-height: 50px;
        object-fit: contain;
      }
    }
  }
`;

const LogoutButton = styled.button`
  display: none;
  
  @media (max-width: 768px) {
    display: block;
    width: 100%;
    max-width: 550px;
    padding: 1rem;
    margin: 2rem auto 0;
    background: transparent;
    border: 2px solid #27aae1;
    color: #27aae1;
    font-size: 16px;
    font-weight: bold;
    text-transform: uppercase;
    cursor: pointer;
    border-radius: 8px;
    transition: all 0.3s ease;
    
    &:hover {
      background: #27aae1;
      color: #fff;
    }
    
    &:active {
      opacity: 0.8;
    }
  }
`;

export default function ConsultaCPF() {
  const [invalidCpf, setInvalidCpf] = useState(null);
  const [cpf, setCPF] = useState('');
  const [loading, setLoading] = useState(false);
  const [documentType, setDocumentType] = useState('IDBRASIL');
  const [documentPlaceholder, setDocumentPlaceholder] = useState('CPF');
  const [tenantSettings, setTenantSettings] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const OptionLabel = ({ iconClassName, label }) => (
    <div className="option-list">
      {iconClassName && <span className={iconClassName}></span>}
      <span>{label}</span>
    </div>
  );
  const [documentOptions] = useState([
    {
      id: 'IDBRASIL',
      label: 'Brasil',
      value: 'IDBRASIL',
      icon: 'fi fi-br'
    },
    {
      id: 'IDANGOLA',
      label: 'Angola',
      value: 'IDANGOLA',
      icon: 'fi fi-ao'
    },
    {
      id: 'IDPORTUGAL',
      label: 'Portugal',
      value: 'IDPORTUGAL',
      icon: 'fi fi-pt'
    },
    {
      id: 'IDAMERICALATINA',
      label: 'América Latina',
      value: 'IDAMERICALATINA',
      icon: ''
    }
  ]);
  const dispatch = useDispatch();

  const selectRef = useRef(null);

  function verifyCpf(e) {
    e.preventDefault();
    const { value } = e.target;
    const result = validateDocs(value, documentType);
    if (!result) {
      switch (documentType) {
        case 'IDPORTUGAL':
          setInvalidCpf('NIF inválido, favor inserir um NIF válido!');
          break;
        case 'IDANGOLA':
          setInvalidCpf('CC inválido, favor inserir um CC válido!');
          break;
        case 'IDAMERICALATINA':
          setInvalidCpf(
            'Número do documento inválido, favor inserir um número válido!'
          );
          break;
        default:
          setInvalidCpf('CPF inválido, favor inserir um CPF válido!');
          break;
      }
    } else {
      setInvalidCpf(null);
    }
  }

  function onChangeCPF(e) {
    setInvalidCpf('');
    setCPF(maskDocs(e.target.value, documentType));
  }

  async function onSubmitForm() {
    try {
      setLoading(true);
      await gateway.post('/person/person/addCpf', {
        cpf
      });

      await handleCpfConsultation(cpf.replace(/\D/g, ''), documentType);
      const idProfile = localStorage.getItem('idProfile');

      let activeContract = false;
      if (localStorage.getItem('activeContract') !== 'undefined') {
        activeContract = JSON.parse(localStorage.getItem('activeContract'));
      }
      adsTracking.sendGoogleAnalyticsEcommerceEvent({
        step: adsTracking.STEP3_VERIFY_CPF
      });
      dispatch(ProfileActions.getProfileRequest(idProfile));
      if (activeContract) {
        if (redirectToLtiCourseIfExists()) {
          setLoading(false);
          return;
        }
        history.push('/home');
      } else {
        history.push('/planos');
      }
      setLoading(false);
    } catch (error) {
      const errorMessage =
        _.get(error, 'response.data.message', undefined) ||
        'Ops, Erro ao consultar documento';

      swal({
        icon: 'warning',
        width: 400,
        title: `Atenção!`,
        content: <p>{errorMessage}</p>
      });
      setLoading(false);
    }
  }

  function handleDocType(e) {
    setDocumentType(e);
    setInvalidCpf('');
    switch (e) {
      case 'IDPORTUGAL':
        return setDocumentPlaceholder('NIF');
      case 'IDANGOLA':
        return setDocumentPlaceholder('CC');
      case 'IDAMERICALATINA':
        return setDocumentPlaceholder('Número do documento');
      default:
        return setDocumentPlaceholder('CPF');
    }
  }

  useEffect(() => {
    // Força a atualização do componente Select após 50ms
    const timeoutId = setTimeout(() => {
      if (selectRef.current) {
        selectRef.current.select.setValue(documentOptions[0]);
      }
    }, 50);

    return () => clearTimeout(timeoutId);
  }, [documentOptions]);

  useEffect(() => {
    // Verificar se é mobile
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    // Buscar configurações do tenant
    const getTenantSettings = () => {
      // Primeiro tenta pegar do domainSettings (usado no cadastro)
      const domainSettings = localStorage.getItem('domainSettings');
      if (domainSettings) {
        try {
          const parsed = JSON.parse(domainSettings);
          setTenantSettings(parsed);
          return;
        } catch (e) {
          console.error('Error parsing domainSettings', e);
        }
      }
      
      // Se não encontrar, tenta pegar do settings (usado no NavBarSuperior)
      const settings = localStorage.getItem('settings');
      const tenant = localStorage.getItem('loginTenant') || localStorage.getItem('tenant');
      
      if (settings && tenant) {
        try {
          const parsed = JSON.parse(settings);
          const tenantConfig = parsed[tenant];
          if (tenantConfig) {
            setTenantSettings(tenantConfig);
            return;
          }
        } catch (e) {
          console.error('Error parsing settings', e);
        }
      }
      
      // Se não encontrar nada, deixa null para usar padrão
      setTenantSettings(null);
    };
    
    getTenantSettings();
  }, []);

  // Obter logo do tenant ou usar padrão (mesma logo da tela de planos)
  const getLogo = () => {
    if (tenantSettings && tenantSettings.logoUrl) {
      return tenantSettings.logoUrl;
    }
    return LogoPlanos;
  };

  // Obter cor de background do tenant ou usar padrão
  const getBackgroundColor = () => {
    if (tenantSettings) {
      return tenantSettings.headerBackgroundColor || 
             tenantSettings.primaryBackgroundColor || 
             '#27aae1';
    }
    return '#27aae1'; // Cor padrão do LIT
  };

  // Função logout (mesma da tela de planos)
  const logout = () => {
    const loginTenantRaw = localStorage.getItem('loginTenant');
    const originRaw = localStorage.getItem('urlOriginParam');

    const loginTenant =
      loginTenantRaw && loginTenantRaw !== 'undefined'
        ? loginTenantRaw.toLowerCase()
        : '';
    const origin =
      originRaw && originRaw !== 'undefined' ? originRaw : '';

    let redirectLoginPath = '/';

    if (loginTenant) {
      redirectLoginPath = `/${loginTenant}`;
    }

    if (origin) {
      const separator = redirectLoginPath.includes('?') ? '&' : '?';
      redirectLoginPath = `${redirectLoginPath}${separator}o=${encodeURIComponent(
        origin
      )}`;
    }

    history.push({
      pathname: '/logout',
      state: {
        redirectLoginPath
      }
    });
  };

  return (
    <>
      {isMobile && (
        <MobileHeader 
          className="navbar navbar-lit navbar-expand-lg p-2"
          style={{ background: getBackgroundColor() }}
        >
          <a className="navbar-brand">
            <img src={getLogo()} alt="Logo" />
          </a>
        </MobileHeader>
      )}
      <Template showHeader={!isMobile}>
        <Container>
        <div className="row d-flex justify-content-center">
          <div className="col-md-12">
            <Text className="text-left">
              Antes de iniciar o seu curso, precisamos de algumas informações:
            </Text>
          </div>
        </div>
        <div className="row d-flex justify-content-center">
          <div className="col-md-12">
            <Text className="box-info-title text-left first">
              Escolha o seu país:
            </Text>
          </div>
          <div className="col-md-12 form-group">
            <Select
              ref={selectRef}
              styles={{
                control: baseStyles => ({
                  ...baseStyles,
                  borderColor: '#27AAE1',
                  padding: '2px 8px'
                })
              }}
              options={documentOptions.map(option => ({
                value: option.value,
                label: (
                  <OptionLabel
                    iconClassName={option.icon}
                    label={option.label}
                  />
                )
              }))}
              onChange={item => handleDocType(item.value)}
              components={{
                SingleValue: ({ children, data }) => (
                  <div className="option-list">
                    {data.icon && <span className={data.icon}></span>}
                    <span>{children}</span>
                  </div>
                )
              }}
            />
          </div>
        </div>
        <div className="row d-flex justify-content-center">
          <div className="col-md-12 form-group">
            <input
              id="cpf"
              type="text"
              className="form-control"
              placeholder={documentPlaceholder}
              name="cpf"
              maxLength="20"
              onBlur={verifyCpf}
              value={cpf}
              onChange={onChangeCPF}
            />
            {invalidCpf && <p style={{ color: 'red' }}>{invalidCpf}</p>}
          </div>
        </div>
        <div className="row d-flex justify-content-center">
          <div className="col-md-12">
            <div className="box-buttons">
              <LitButton
                disabled={invalidCpf || loading || !cpf}
                style={{
                  marginTop: '0px',
                  textTransform: 'uppercase'
                }}
                onClick={onSubmitForm}
                className={`${loading && ' btn-loading'}`}
              >
                Confirmar
              </LitButton>
            </div>
          </div>
        </div>
        <div
          className="row d-flex justify-content-flex-start"
          style={{ marginTop: 20 }}
        >
          <div className="col-md-12">
            <Text className="text-left">
              Por que precisamos do seu documento?
            </Text>
            <section style={{ marginTop: 10 }}>
              <Text
                className="box-info-title"
                style={{ marginBottom: 0, fontWeight: 300 }}
              >
                Uma identificação única é necessária para:
              </Text>
              <ul style={{ listStyleType: 'circle', padding: '5px 15px' }}>
                <li>
                  Garantir que seus certificados sejam emitidos de forma correta
                </li>
                <li>
                  Recuperar seus progressos anteriores, caso seja ex-aluno LIT
                </li>
                <li>
                  Caso seja colaborador de uma empresa parceira, você terá
                  acesso a planos especiais
                </li>
              </ul>
            </section>
          </div>
        </div>
        {isMobile && (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '0 1em' }}>
            <LogoutButton onClick={logout}>
              SAIR
            </LogoutButton>
          </div>
        )}
      </Container>
      </Template>
    </>
  );
}
